import { configurationPolicies as policies } from 'helpers';
import Schema from './schema';


export default class Configuration extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      ansible_runer_path:'',
      ansible_config:'',
      mail_host:'',
      mail_port: 0,
      mail_secure: false,
      mail_user: '',
      mail_pass: '',
      mail_rejectUnauthorized: false,
      mail_from: '',
      threads: '',
      inventory_path: '',
      macros_playbook_path: '',
      macros_playbook: '',
      macros_config_path: ''
    });
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.setDefaultValues(data);
  }
}
